import { GET_BRICS_TRACKS } from '../contants';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  data: [],
};

export default function bricsCities(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_BRICS_TRACKS}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        data: {},
      };
    case `${GET_BRICS_TRACKS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        data: [...action.result, { Id: 'BOTH', Label: 'Both Tracks' }],
      };
    case `${GET_BRICS_TRACKS}_FAIL`:
      return {
        ...state,
        error: action.result,
        loaded: false,
        loading: false,
        data: {},
      };
    default:
      return state;
  }
}
